import {
  FormErrorMessageProps,
  FormHelperTextProps,
  FormLabelProps,
} from '@chakra-ui/react';
import { IdType, ProfileImageSize, SocialType } from 'types/enums';
import { EnumValidation } from 'types/generic.types';
import { CancelTokenSource } from 'axios';
import { Link } from 'types/api.types';

export interface Time {
  timestamp: number;
  iso: string;
}

export type Platform = 'win32' | 'darwin' | 'linux';

export const IdTypeLabel = {
  [IdType.IPI]: 'IPI',
  [IdType.IPN]: 'IPN',
  [IdType.ISNI]: 'ISNI',
};

export const SocialTypeLabel = {
  [SocialType.APPLE]: 'Apple Music',
  [SocialType.SPOTIFY]: 'Spotify',
  [SocialType.YOUTUBE]: 'YouTube',
};

// REFACTOR: Make name more descriptive.
export interface Option {
  value: string | number;
  title: string;
  [index: string]: any;
}

export type ContextMenuOption = Option & {
  onClick?: () => void;
  isDisabled?: boolean;
};

export interface Settings {
  badge: {
    visible: boolean;
  };
}

export interface ElectronAppInfo {
  argv: string[];
  appName: string;
  appVersion: string;
  platform: Platform;
}

export interface Country {
  countryCode: string;
  name: string;
}

export type SortOrder = 'asc' | 'desc';

export interface StringValidation {
  minLength: number;
  maxLength: number;
  pattern?: string;
}

export interface NumberValidation {
  minimum: number;
  maximum: number;
}

export interface GenreValidation {
  items: {
    properties: {
      genre: EnumValidation;
    };
  };
}

export interface PatternValidation {
  pattern: string;
  type: string | string[];
}

export type DDL = {
  [index: string]: { key: string; name: string };
};

export interface PrivacySettings {
  isSearchable: boolean;
}

export interface CropOptions {
  width: number;
  height: number;
  left: number;
  top: number;
}

export interface ImageAttributes {
  height: number;
  width: number;
  naturalHeight: number;
  naturalWidth: number;
}

export interface DataTestId {
  'data-testid'?: string;
}

export interface ProfileImage {
  href: string;
  name: ProfileImageSize;
}

export interface FormLabelPropsWithTestId extends FormLabelProps {
  'data-testid'?: string;
}

export interface HelpTextPropsWithTestId extends FormHelperTextProps {
  'data-testid'?: string;
}

export interface FormErrorMessagePropsWithTestId extends FormErrorMessageProps {
  'data-testid'?: string;
}

export interface UploadImageRequestData {
  image: {
    fileName: string;
    base64: string;
    file: File;
    cropOptions: CropOptions;
  };
  cancelTokenSource?: CancelTokenSource;
}

export interface Image {
  guid: string;
  createdBy: string;
  fileName: string;
  status: string;
  visibility: string;
  created: Time;
  updated: Time;
  parent: string;
  _links: {
    upload: Link;
    uploadStatus: Link;
  };
}

export type DisabledAudios = { audios: string[]; reason: string };
